import {createAsyncThunk} from '@reduxjs/toolkit';
import {AppThunkApiConfig} from '../../createStore';
import {OpeningDayException} from '../entities';
import {mapiqApi} from '@lib/infrastructure';
import parseISO from 'date-fns/parseISO';
import {toOpeningDaysExceptions} from './mappers/openingDayExceptionMapper';

export const loadOpeningDaysExceptions = createAsyncThunk<
  OpeningDayException[],
  {from: string; to: string},
  AppThunkApiConfig
>('openingDays/loadOpeningDaysExceptions', async ({from: fromDateString, to: toDateString}, {extra}) => {
  const client = extra.apiClient;
  const api = mapiqApi(client);
  const from = parseISO(fromDateString);
  const to = parseISO(toDateString);
  const openingDaysExceptionsResponse = await api.getOpeningDayExceptions(from, to);

  return toOpeningDaysExceptions(openingDaysExceptionsResponse);
});
